const Filiais = () => {
    return (
        <>
            <option value="" selected >Selecione uma loja...</option>
            <option value="Realengo">Realengo</option>
            <option value="Rio Centro">Rio Centro</option>
            <option value="Taquara">Taquara</option>
            <option value="Angra">Angra</option>
            <option value="São João">São João</option>
            <option value="Inhaúma">Inhaúma</option>
            <option value="Niterói">Niterói</option>
            <option value="Caxias">Caxias</option>
            <option value="Teresópolis">Teresópolis</option>
            <option value="Macaé">Macaé</option>
            <option value="Araruama">Araruama</option>
            <option value="Angra II">Angra II</option>
            <option value="São Pedro da Aldeia">São Pedro da Aldeia</option>
            <option value="Campo Grande">Campo Grande</option>
        </>
    );
}

export default Filiais;